import React, { useState,useEffect } from 'react'
import Footer from '../inc/Footer'
import MyBidsComp from '../inc/MyBidsComp'
import axios from "axios";
import "../inc/GlobalVars";
import Loader from '../inc/Loader';

function MyBids() {
  const [biddingListItems, setBiddingListItems] = useState([]);
  const[loading,setLoading] = useState(false);
  const user_id = localStorage.getItem('userId');
 async function getBiddingList() {
  setLoading(true);
    try {
      const resp = await axios.get(global.apiUrl + "/getUserBidding/"+user_id).then(function (response) {
        const biddingData = response.data["data"];
        setBiddingListItems(biddingData);
        setLoading(false);
      }); 
    }
    catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    getBiddingList();
  }, []);
  return (
    <div>
      {loading ? ( <Loader /> ) : (
<>
      <div className='container'>
            <div className='row'>
            <div className="col-md-12 mb-5  mt-5 pt-5">
            <h1>My Bids</h1>
            </div>
            <div className='col-md-12 d-flex justify-content-center'>
              <div className='col-md-10'>
              {
                biddingListItems.length > 0 ? (
                biddingListItems.map((ac, key) => (
            <MyBidsComp key={key} make_name={ac.make_name}
            model={ac.model} vehicle_id={ac.vehicle_id} reg_number={ac.reg_number} featured_image={ac.featured_image} bid_amount={ac.bid_amount} bid_status={ac.bid_status} />
            ))) : (
                <h2>No Bid Placed</h2>
              )
            }
              </div>
            </div>
            </div>
        </div>
        
    
        <Footer />

        
</> )}</div> );
}

export default MyBids